import React, { Dispatch, SetStateAction } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';

import { UseOutletContextAccounting } from '../Accounting';
import { Company } from '../../../../models/company.model';
import { AccountingAccount } from '../../../../models/accounting.account.model';
import { Contact } from '../../../../models/contact.model';

export interface PlanPageProps {};

type ContexType = {
  setRoute: Dispatch<SetStateAction<{path: {root: string, branch: string} | null, company: boolean} | null>>,
  companyForUser: Company | null,
  accountingAccountsForCompany: AccountingAccount[] | null
  contactsForCompany: Contact[] | null
};

const PlanPage: React.FunctionComponent<PlanPageProps> = props => {
  const {setRoute, companyForUser, accountingAccountsForCompany, contactsForCompany} = UseOutletContextAccounting()

  return (
    <Outlet context={{setRoute, companyForUser, accountingAccountsForCompany, contactsForCompany}}></Outlet>
  );
}

export function UseOutletContextPlan() {
  return useOutletContext<ContexType>()
};

export default PlanPage;
